import { prettifyName, useSearchParams } from "@Utils";
import { Breadcrumb, Menu } from "antd";
import { MenuInfo } from "rc-menu/lib/interface";
import React from "react";
import { Link } from "react-router-dom";
import { IAssessmentPageProps, SELECTION_TABS } from "./types";

const AssessmentBreadcrumbs: React.FC<IAssessmentPageProps> = ({ hasSubmissions }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const assessmentParam = searchParams.get("assessment");
  const tabParam = searchParams.get("tab");

  const hasMenu = SELECTION_TABS.map<string>((st) => st).includes(tabParam);

  const handleMenuItemClick = ({ key }: MenuInfo) => setSearchParams({ tab: key, assessment: assessmentParam });

  const breadcrumbMenu = (
    <Menu
      onClick={handleMenuItemClick}
      items={SELECTION_TABS.map((key) => {
        const disabled = key === "submissions" && !hasSubmissions;

        return { key, disabled, label: prettifyName(key) };
      })}
    />
  );

  return (
    <Breadcrumb separator="|">
      <Breadcrumb.Item>
        <Link to="/assessments">Assessments</Link>
      </Breadcrumb.Item>
      {hasMenu ? <Breadcrumb.Item overlay={breadcrumbMenu}>{prettifyName(tabParam)}</Breadcrumb.Item> : null}
    </Breadcrumb>
  );
};

export default AssessmentBreadcrumbs;
